const COOKIE_NAME = 'pendingSchoolId';
const COOKIE_DAYS = 30;

export const schoolCookie = {
  get: () => {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  },

  set: (schoolId) => {
    const expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(schoolId)}; expires=${expires}; path=/; SameSite=Lax`;
  },

  clear: () => {
    document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
  },
};
